import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useCart } from '../context/CartContext';
import { Heart, ShoppingCart, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export const Wishlist = () => {
  const navigate = useNavigate();
  const { wishlist, removeFromWishlist, addToCart } = useCart();

  const handleAddToCart = (product) => {
    addToCart(product);
    toast.success('Added to cart!');
  };

  if (wishlist.length === 0) {
    return (
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 text-center">
        <Heart size={64} className="mx-auto text-gray-300 mb-6" />
        <h2 className="text-2xl font-bold mb-4" data-testid="empty-wishlist-title">Your wishlist is empty</h2>
        <p className="text-gray-600 mb-8">Save items you love for later!</p>
        <Button onClick={() => navigate('/products')} className="bg-[#D4AF37] text-white hover:bg-[#c9a22e]" data-testid="browse-products-btn">
          Browse Products
        </Button>
      </div>
    );
  }

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12">
      <h1 className="text-3xl md:text-4xl font-bold mb-8" style={{fontFamily: 'Playfair Display, serif'}} data-testid="wishlist-title">
        My Wishlist
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {wishlist.map((product) => (
          <div key={product.id} className="card card-hover overflow-hidden relative" data-testid={`wishlist-item-${product.id}`}>
            <button
              onClick={() => {
                removeFromWishlist(product.id);
                toast.success('Removed from wishlist');
              }}
              className="absolute top-4 right-4 z-10 bg-white p-2 rounded-full shadow-md hover:scale-110 transition-transform"
              data-testid={`remove-wishlist-${product.id}`}
            >
              <Trash2 size={18} className="text-red-500" />
            </button>

            <div className="aspect-square overflow-hidden cursor-pointer" onClick={() => navigate(`/products/${product.id}`)}>
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
              />
            </div>

            <div className="p-6">
              <p className="text-xs text-[#D4AF37] mb-2 uppercase tracking-wide">{product.category}</p>
              <h3 className="font-bold text-lg mb-2 cursor-pointer hover:text-[#D4AF37]" onClick={() => navigate(`/products/${product.id}`)}>
                {product.name}
              </h3>
              <p className="text-gray-600 text-sm mb-4 line-clamp-2">{product.description}</p>
              
              <div className="flex items-center gap-2 mb-4">
                <span className="text-[#D4AF37] font-bold text-xl">₹{product.price}</span>
                {product.originalPrice && (
                  <span className="text-gray-400 line-through text-sm">₹{product.originalPrice}</span>
                )}
              </div>

              <Button
                onClick={() => handleAddToCart(product)}
                className="w-full bg-[#D4AF37] text-white hover:bg-[#c9a22e]"
                data-testid={`add-to-cart-wishlist-${product.id}`}
              >
                <ShoppingCart className="mr-2" size={18} />
                Add to Cart
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
